import { render, staticRenderFns } from "./AddOrUpdateOfferingTypeForm.vue?vue&type=template&id=1651c3ca&"
import script from "./AddOrUpdateOfferingTypeForm.vue?vue&type=script&lang=js&"
export * from "./AddOrUpdateOfferingTypeForm.vue?vue&type=script&lang=js&"
import style0 from "./AddOrUpdateOfferingTypeForm.vue?vue&type=style&index=0&id=1651c3ca&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports